import { ESuburbanOfferFilter } from '@cian/api-models/common/json_query';
import * as R from 'ramda';
import { connect } from 'react-redux';

import { TThunkDispatch, IReduxState } from '../../types/redux';
import { setPosessor } from '../../actions/filters';
import { FilterPosessor, IFilterPosessorProps } from '../../components/FilterPosessor';

type TFilterPosessorStateProps = Pick<IFilterPosessorProps, 'value'>;
type TFilterPosessorDispatchProps = Pick<IFilterPosessorProps, 'onSelect'>;

export function mapStateToProps(state: IReduxState): TFilterPosessorStateProps {
  const { jsonQuery } = state.filters;

  return {
    value: R.pathOr(ESuburbanOfferFilter.Any, ['suburban_offer_filter', 'value'], jsonQuery),
  };
}

export function mapDispatchToProps(dispatch: TThunkDispatch): TFilterPosessorDispatchProps {
  return {
    onSelect: (posessor: ESuburbanOfferFilter) => dispatch(setPosessor(posessor)),
  };
}

export const FilterPosessorContainer = connect(mapStateToProps, mapDispatchToProps)(FilterPosessor);
